import { render, staticRenderFns } from "./datacollect.vue?vue&type=template&id=a4b04244&scoped=true&"
import script from "./datacollect.vue?vue&type=script&lang=ts&"
export * from "./datacollect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b04244",
  null
  
)

export default component.exports